import Choices from 'choices.js';

export default {
  init() { },
  finalize() {
    let currentData;
    let updateFilterData = () => {

      let data = {
        from: startDateEl.value,
        to: endDateEl.value,
        tags: tagElChoices.getValue(true),
        cats: catElChoices.getValue(true),
      };

      Object.keys(data).forEach(key => {
        if (!data[key]) delete data[key];
      });

      currentData = data;
    };

    let updateResults = () => {
      updateFilterData();

      let params = { action: 'news_filter', ...currentData };
      let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

      sectionLoop.classList.add('is-loading');

      fetch('/wp/wp-admin/admin-ajax.php?action=news_filter', {
        method: 'POST',
        body: queryString,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
      })
        .then(response => response.text())
        .then(body => {
          sectionLoop.classList.remove('is-loading');
          newsWrapper.innerHTML = body;
        });
    };

    let defaultChoicesOptions = {
      searchEnabled: true,
      renderChoiceLimit: 6,
      noResultsText: 'Nessun risultato',
    };

    let startDateEl = document.querySelector('.ArchiveFilters__StartDate input');
    let endDateEl = document.querySelector('.ArchiveFilters__EndDate input');
    let tagEl = document.querySelector('.ArchiveFilters__Tag select');
    let tagElChoices = new Choices(tagEl, defaultChoicesOptions);
    let catEl = document.querySelector('.ArchiveFilters__Category select');
    let catElChoices = new Choices(catEl, defaultChoicesOptions);

    let newsWrapper = document.querySelector('.ArchiveLoop__Wrapper');
    let sectionLoop = document.querySelector('.ArchiveLoop');

    updateFilterData();

    [startDateEl, endDateEl, tagEl, catEl].forEach((input) => { input.addEventListener('change', updateResults) });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/archive.js